import React, { PureComponent } from 'react';
import { withTranslation, Trans } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _ from 'lodash';

import './BetslipContainer.scss';
import Betslip from './Betslip/Betslip';
import BetResult from './BetResult/BetResult';
import MyBets from './MyBets/MyBets';
import BetInfo from './BetInfo/BetInfo';
import AppModeContext from '../../containers/AppMode/AppMode.context';
import Icon from '../Icon/Icon';
import { betsToBetslipFormat } from 'src/utils/utils';
import LoadBets from './LoadBets/LoadBets';

class BetslipContainer extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      selectedTab: 0,
      myBetsCount: 0,
      ticketNumber: ''
    };

    if (props.forwardRef) {
      props.forwardRef.current = this;
    }
  }

  onTabChange = (event, value) => {
    this.setState({ selectedTab: value });
  }

  reuseSelections = async (e) => {
    e.preventDefault();
    this.props.reuseLastSelections();
  };

  shouldComponentUpdate(nextprops){
    if ((this.props.bets.length === 0 && nextprops.bets.length > 0) ||
    (this.props.bets.length > 0 && nextprops.bets.length === 0) ||
     !_.isEqual(this.props.matrix, nextprops.matrix) ||
     this.state.selectedTab !== nextprops.selectedTab) {
      return true;
    }
    return false;
  }

  getTicket = async (e) => {
    e.preventDefault();
    const response = await this.props.getTicketDetails({ ticket: this.state.ticketNumber });

    const bets = betsToBetslipFormat(response.bets);
    await this.props.addBets(bets);
    if (response.betType === 3){
      this.props.changeIsGetTicket(true);
      await this.props.changeSlip(2);
      const selectedLines = [];

      const stakes = [];
      let isStakePerSystem = true;
      const stakePerSystem = [];
      for (const index in response.stakes.combinations){
        if (response.stakes.combinations[index].stake > 0 && !selectedLines.includes(response.stakes.combinations[index].lines.length)){
          selectedLines.push(response.stakes.combinations[index].lines.length);
        }
        stakes.push({ index: +index, value:response.stakes.combinations[index].stake / 100 });

        if (+index > 0 &&
            response.stakes.combinations[+index].lines.length === response.stakes.combinations[+index -1].lines.length &&
            response.stakes.combinations[index].stake !== response.stakes.combinations[index -1].stake
        ){
          isStakePerSystem = false;
        }

        if (+index < response.stakes.combinations.length - 1 &&
             response.stakes.combinations[+index].lines.length !== response.stakes.combinations[+index +1].lines.length && isStakePerSystem){
          stakePerSystem[response.stakes.combinations[index].lines.length -1] = response.stakes.combinations[index].stake;
        }
      }
      if (!isStakePerSystem){
        await this.props.updateAllSystemStakes(response.stakes.combinations);
        await this.props.addMultipleSelectedCombinations(selectedLines);
        await this.props.changeStakeSelection('differentStake');
        await this.props.updateMultipleSystemStakes(stakes);
      } else if (isStakePerSystem){
        await this.props.updateAllSystemStakes(response.stakes.combinations);
        await this.props.addMultipleSelectedCombinations(selectedLines);
        await this.props.changeStakeSelection('stakePerSystem');
        await this.props.changeStakePerSystem(Array.from(stakePerSystem, item => item || null));
        await this.props.updateMultipleSystemStakes(stakes);
      }
    } else if (response.betType === 2) {
      await this.props.changeSlip(1);

      if (response.stakeType === 2){
        await this.props.changeStakeSelection('sameStake');
        this.props.updateBetStake({ value: +response.stake / 100 });
      } else {
        this.props.updateBetStake({ value: +response.totalStake / 100 });
      }
    } else {
      await this.props.changeSlip(0);
      if (response.stakeType === 2){
        await this.props.changeStakeSelection('sameStake');
        this.props.updateBetStake({ value: +response.stake / 100 });
      } else if (response.stakeType === 3){
        await this.props.changeStakeSelection('differentStake');
        this.props.updateMultipleSingleStakes(Array.from(response.stakes.combinations, item => item.singleStake));
      } else if (response.stakeType === 1){
        await this.props.changeStakeSelection('totalStake');
        this.props.updateBetStake({ value: +response.totalStake / 100 });
      }
      this.props.changeIsGetTicket(false);
    }
  };

  renderEmptyWrapper = () => {
    const { tempBets } = this.props;

    return (
      <>
        {
          !_.isEmpty(this.props.betResult) && this.props.betResult !== null
            ? <BetResult />
            : (
              <div className="betslip-wrapper">
                <div className="betslip-wrapper__no-bets">
                  {
                    (!this.context.RETAIL_MODE || (tempBets.bets && tempBets.bets > 0)) && <Trans i18nKey="betslip.noBets">
                      <br />
                    </Trans>
                  }
                  {
                    !(tempBets.bets && tempBets.bets === 0)  && <LoadBets />
                  }
                  {
                    (tempBets.bets && tempBets.bets > 0) &&
                    <>
                      <LoadBets />
                    </>
                  }
                </div>
              </div>
            )
        }
      </>
    );
  }

  renderMyBetsWrapper = () => {
    return (
      <div className="bets-wrapper">
        <MyBets />
      </div>
    );
  }

  handleCollapse = () => {
    const { RETAIL_MODE } = this.context;

    this.props.changeSidebarCollapsed({ sidebar: 'rightSideBar', isRetail: RETAIL_MODE, width: window.innerWidth });
  }

  render() {
    const { t, bets, betResult, matrix, myBetsCount } = this.props;
    const { selectedTab } = this.state;

    return (
      <div className="betslip-container">
        { this.context.RETAIL_MODE && !_.isEmpty(matrix.matrix) &&  <BetInfo /> }
        <div className="betslip-container__tabs">
          <button
            type="button"
            value={ 0 }
            onClick={ () => this.setState({ selectedTab: 0 }) }
            className={
              classNames({
                'betslip-container__tab': true,
                'betslip-container__tab--selected': selectedTab === 0,
                'betslip-container__tab--retail': this.context.RETAIL_MODE
              })
            }
          >
            <>
              { t('betslip.betslipTab') }
              { bets.length > 0 && <span className="betslip-container__tab-tooltip">{ bets.length }</span> }
            </>
          </button>
          {
            !this.context.RETAIL_MODE && (
              <button
                type="button"
                value={ 1 }
                onClick={ () => this.setState({ selectedTab: 1 }) }
                className={
                  classNames({
                    'betslip-container__tab': true,
                    'betslip-container__tab--selected': selectedTab === 1,
                    'betslip-container__tab--retail': this.context.RETAIL_MODE
                  })
                }
              >
                <>
                  { t('betslip.myBetsTab') }
                  { +myBetsCount > 0 && <span className="betslip-container__tab-tooltip">{ myBetsCount }</span> }
                </>
              </button>
            )
          }
          <button onClick={ this.handleCollapse } className="betslip-container__collapse">
            <Icon icon="minimize" />
          </button>
        </div>
        { selectedTab === 0 && bets.length > 0 && _.isNull(betResult) && <Betslip /> }
        { selectedTab === 0 && (bets.length === 0 || !_.isNull(betResult)) && this.renderEmptyWrapper() }
        { selectedTab === 1 && this.renderMyBetsWrapper() }
      </div>
    );
  }
}

BetslipContainer.propTypes = {
  t: PropTypes.func,
  forwardRef: PropTypes.object,
  bets: PropTypes.array,
  betResult: PropTypes.object,
  matrix: PropTypes.object,
  getBetHistoryCount: PropTypes.func,
  customer: PropTypes.object,
  myBetsCount: PropTypes.number,
  changeSidebarCollapsed: PropTypes.func,
  reuseLastSelections: PropTypes.func,
  tempBets: PropTypes.array,
  getTicketDetails: PropTypes.func,
  addBets: PropTypes.func,
  changeSlip: PropTypes.func,
  updateMultipleSystemStakes: PropTypes.func,
  changeStakeSelection: PropTypes.func,
  addMultipleSelectedCombinations: PropTypes.func,
  updateAllSystemStakes: PropTypes.func,
  changeStakePerSystem: PropTypes.func,
  updateBetStake: PropTypes.func,
  updateMultipleSingleStakes: PropTypes.func,
  changeIsGetTicket: PropTypes.func
};

const mapState = state => ({
  bets: state.betslip.bets,
  betResult: state.betslip.betResult,
  matrix: state.peripherals.omr.data.matrix,
  myBetsCount: state.account.myBetsCount,
  customer: state.auth.customer,
  tempBets: state.betslip.tempBets
});

const mapDispatch = dispatch => ({
  getBetHistoryCount: () => dispatch.account.getBetHistoryCount(),
  changeSidebarCollapsed: (sidebar) => dispatch.content.changeSidebarCollapsed(sidebar),
  reuseLastSelections: () => dispatch.betslip.reuseLastSelections(),
  getTicketDetails: (payload) => dispatch.peripherals.getTicketDetails(payload),
  addBets: (payload) => dispatch.betslip.addBets(payload),
  changeSlip: (payload) => dispatch.betslip.changeSlip(payload),
  updateMultipleSystemStakes: (payload) => dispatch.betslip.updateMultipleSystemStakes(payload),
  changeStakeSelection: (payload) => dispatch.betslip.changeStakeSelection(payload),
  updateAllSystemStakes: (payload) => dispatch.betslip.updateAllSystemStakes(payload),
  addMultipleSelectedCombinations: (payload) => dispatch.betslip.addMultipleSelectedCombinations(payload),
  changeStakePerSystem: (payload) => dispatch.betslip.changeStakePerSystem(payload),
  updateBetStake: (payload) =>  dispatch.betslip.updateBetStake(payload),
  updateMultipleSingleStakes: (payload) => dispatch.betslip.updateMultipleSingleStakes(payload),
  changeIsGetTicket: (payload) => dispatch.betslip.changeIsGetTicket(payload)
});

BetslipContainer.contextType = AppModeContext;

export default withRouter(connect(mapState, mapDispatch)(withTranslation('common')(BetslipContainer)));
